import React, { useContext, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { MyContext } from "../dashboard/Dashboard";
import { CreateUserApi } from "../../api/UserCreationApi";

import spinner from "../../assets/images/spinner.gif";

const CreateUser = () => {
  const { setValue } = useContext(MyContext);
  const [data, setData] = useState({
    userName: "",
    password: "",
    designation: "",
    name: "",
    master_code: "",
    department: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue("Create User");
  });

  const checkBoxHandler = (e) => {
    const { value, checked } = e.target;
    const { department } = data;
    if (checked) {
      // setData({ ...data, department: [...department, value] });
      setData({ ...data, department: value });
    } else {
      setData({ ...data, department: department.filter((e) => e !== value) });
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      !data.userName ||
      !data.designation ||
      !data.password ||
      !data.master_code ||
      !data.department.length
    ) {
      NotificationManager.warning("Please provide details", "Incomplete Data");
    } else {
      setLoading(true);
      try {
        const response = await CreateUserApi(data);
        setLoading(false);
        if (response.data) {
          // if response do something
          setData({
            userName: "",
            password: "",
            designation: "",
            name: "",
            master_code: "",
            department: [],
          });
        } else {
          NotificationManager.error(
            response.status_message,
            "Failed to Create User"
          );
        }
      } catch (error) {
        console.log("User Creation Failed: " + error);
        setLoading(false);
        NotificationManager.error(
          "Network error. Please check your connection",
          "Failed to Create User"
        );
      }
    }
  };
  return (
    <>
      <div className="px-6 pt-6 2xl:container">
        <div className="w-full px-6 py-8 rounded-lg shadow-lg bg-white">
          <div className="overflow-x-auto w-full">
            <form className="grid grid-cols-1 md:grid-cols-2 flex  gap-4 md:gap-6">
              <div>
                <label
                  htmlFor="userName"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Username
                </label>
                <input
                  type="text"
                  value={data.userName || ""}
                  name="userName"
                  id="userName"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter User Name"
                  onChange={(e) =>
                    setData(() => ({ ...data, userName: e.target.value }))
                  }
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password
                </label>
                <input
                  type="password"
                  value={data.password || ""}
                  name="password"
                  id="password"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter Password"
                  onChange={(e) =>
                    setData(() => ({ ...data, password: e.target.value }))
                  }
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="name"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={data.name || ""}
                  id="name"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter Name"
                  onChange={(e) =>
                    setData(() => ({ ...data, name: e.target.value }))
                  }
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="masterCode"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Master Code
                </label>
                <input
                  type="text"
                  name="masterCode"
                  value={data.master_code || ""}
                  id="masterCode"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter Master Code"
                  onChange={(e) =>
                    setData(() => ({ ...data, master_code: e.target.value }))
                  }
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="designation"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Designation
                </label>
                <input
                  type="text"
                  name="designation"
                  value={data.designation || ""}
                  id="designation"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter Designation"
                  onChange={(e) =>
                    setData(() => ({ ...data, designation: e.target.value }))
                  }
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="department"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Department
                </label>
                <div className="flex flex-wrap gap-x-4 gap-y-2">
                  <label className="label cursor-pointer gap-x-2">
                    <input
                      type="checkbox"
                      name="department"
                      className="checkbox"
                      value="1"
                      onChange={checkBoxHandler}
                    />
                    <span className="label-text w-max">Department 1</span>
                  </label>
                  <label className="label cursor-pointer gap-x-2">
                    <input
                      type="checkbox"
                      name="department"
                      className="checkbox"
                      value="2"
                      onChange={checkBoxHandler}
                    />
                    <span className="label-text w-max">Department 2</span>
                  </label>
                  <label className="label cursor-pointer gap-x-2">
                    <input
                      type="checkbox"
                      name="department"
                      className="checkbox"
                      value="3"
                      onChange={checkBoxHandler}
                    />
                    <span className="label-text w-max">Department 3</span>
                  </label>
                  <label className="label cursor-pointer gap-x-2">
                    <input
                      type="checkbox"
                      name="department"
                      className="checkbox"
                      value="4"
                      onChange={checkBoxHandler}
                    />
                    <span className="label-text w-max">Department 4</span>
                  </label>
                </div>
              </div>
              <button
                onClick={submitHandler}
                disabled={loading ? "disabled" : ""}
                className="w-1/2 mx-auto col-span-2 text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer cursor-pointer"
              >
                <img
                  className={(loading ? "inline" : "hidden") + " mr-2 max-h-4"}
                  src={spinner}
                  alt="loading... "
                />
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default CreateUser;
